export default __webpack_public_path__ + "static/bz-224e3b4d5fa6d8e404b0a94cf3c7558f.svg";